export default __webpack_public_path__ + "static/media/download-Disable.45b935d6.svg";